import React from 'react'
import { useIntl } from 'react-intl'
import useRangeDate from '../../../utils/hooks/useDateRange'
import Button from '../buttons'
import LabeledCalendar from '../form-components/labeled-calendar/LabeledCalendar'
import './filterDateRange.scss'

const FilterDateRange = ({ minDate, maxDate, onClick }) => {
  const { formatMessage: msg } = useIntl()

  const { initDate, finishDate, onChangeRange, checkRange } = useRangeDate({
    minDate,
    maxDate,
  })

  return (
    <div className="line-date-range-consumption">
      <LabeledCalendar
        idLabel="date.init"
        name="initDate"
        hourFormat={false}
        value={initDate}
        onChange={onChangeRange}
      />
      <LabeledCalendar
        idLabel="date.finish"
        name="finishDate"
        value={finishDate}
        onChange={onChangeRange}
        minDate={initDate}
      />
      <Button
        btnText={msg({ id: 'filter' })}
        btnType="button"
        btnClass="btn__bg-orange"
        onHandleClick={() => onClick(initDate, finishDate)}
        iconRight
        iconClass="pi-filter"
        isDisabled={!checkRange()}
      />
    </div>
  )
}

export default FilterDateRange
